import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const OutboundDeliveriesQuery = graphql(/* GraphQL */ `
  query GetOutboundDeliveries($input: OutboundDeliverySearchInput!) {
    outboundDeliveries(input: $input) {
      data {
        id
        deliveryNumber
        status
        carrierTenantId
        carrierTenantName
        packingStatus
        goodsIssueStatus
        pickingStatus
        itemCount
        createdAt
        changedAt
        owner
        partners {
          outboundDeliveryPartnerId
          businessPartnerId
          businessPartnerNumber
          companyName
          role
        }
        items {
          id
          itemNumber
          materialId
          owner
          quantities {
            outboundDeliveryItemQuantityId
            quantityRole
            quantityRoleCategory
            quantity
            unitOfMeasurement
          }
        }
        times {
          outboundDeliveryTimeId
          type
          category
          date
          time
        }
      }
    }
  }
`);
